module.exports = __webpack_public_path__ + "img/video6.dd156128.png";